import { VabsPaymentSourceOfFunds } from '../api/apollo';
import { ISelectOption } from './components/select';
import { Select } from './components/select/ui/select';

const enumLabel = (value: string) => {
  const words = value.toLowerCase().split('_');
  return words
    .map((word, idx) =>
      idx === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word,
    )
    .join(' ');
};

export const OPTIONS = Object.values(VabsPaymentSourceOfFunds).map((v) => ({
  value: v,
  label: enumLabel(v),
}));

export const VabsSFSelect: React.FC<{
  value: VabsPaymentSourceOfFunds;
  onSelect: (v: VabsPaymentSourceOfFunds) => void;
  errorText?: string;
}> = ({ value, onSelect, errorText }) => {
  const option = OPTIONS.find((i) => i.value === value);
  const handleSelect = (option) => {
    onSelect(option.value);
  };
  return (
    <Select
      variant="send"
      placeholder="Source of funds"
      options={OPTIONS}
      value={option as ISelectOption}
      onSelect={handleSelect}
      isInvalid={!!errorText}
    />
  );
};
